export function base64StringToFile(base64: string, filename: string, type: string, lastModified?: number) {
    const binaryString = atob(base64);
    const uint8array = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        uint8array[i] = binaryString.charCodeAt(i);
    }

    return new File([uint8array], filename, { lastModified: lastModified ?? Date.now(), type });
}

export function fileToBase64(file: File) {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // Extract the base64 part from the data URL
            const base64String = (reader.result as string).split(",")[1];
            resolve(base64String);
        };
        reader.onerror = reject;
    });
}

export const fileToArrayBuffer = (f: File): Promise<ArrayBuffer> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(f);
        reader.onload = () => resolve(reader.result as ArrayBuffer);
        reader.onerror = (error) => reject(error);
    });
};
